import { Button } from "@chakra-ui/button";
import { Box, Flex, Grid, HStack, Link, Stack, Text } from "@chakra-ui/layout";
import {
  faBookmark,
  faFilter,
  faList,
  faThLarge,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import programs from "../lib/programs.json";
import { ProgramCard, ProgramList } from "../component/programView";
import {
  PersonalProgramCard,
  PersonalProgramList,
} from "../component/PersonalProgramView";
import { Route, Switch, useHistory } from "react-router";
import Programs from "./programs/Programs";
import SubscribeToProgram from "../component/SubscribeToProgram";

const KnowledgeBank = () => {
  const [suggestedPrograms, setSuggestedPrograms] = useState([]);
  const [personalPrograms, setPersonalPrograms] = useState([]);
  const [view, setView] = useState("grid");
  const history = useHistory();

  useEffect(() => {
    // Personal programs
    let personal = programs.filter(
      (program) => program.programType === "personal"
    );
    // we only need to display the first four personal programs
    setPersonalPrograms(personal.slice(0, 4));

    // Suggested programs
    let suggested = programs.filter(
      (program) => program.programType === "suggested"
    );

    // we only need to display the first four suggested programs
    setSuggestedPrograms(suggested.slice(0, 4));
  }, []);

  const switchView = (view) => {
    setView(view);
  };

  const initCreateProgram = () => {
    history.push("/dashboard/knowledge-bank/programs/new");
  };

  return (
    <Switch>
      <Route exact path="/dashboard/knowledge-bank">
        <>
          <Box sx={{ bg: "#f2f2f2" }}>
            <Container>
              <Flex py="4" justify="space-between" align="center">
                <Text fontSize="22px" fontWeight="bold">
                  knowledgeBank
                </Text>

                <Box>
                  <HStack spacing={5}>
                    <Box color="#223D5D" sx={{ cursor: "pointer" }}>
                      <FontAwesomeIcon icon={faFilter} />
                    </Box>
                    <Box
                      onClick={() => switchView("list")}
                      color="#223D5D"
                      sx={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={faList} />
                    </Box>
                    <Box
                      onClick={() => switchView("grid")}
                      color="#223D5D"
                      sx={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={faThLarge} />
                    </Box>
                    <Box color="#223D5D" sx={{ cursor: "pointer" }}>
                      <FontAwesomeIcon icon={faBookmark} />
                    </Box>
                    <Button
                      onClick={initCreateProgram}
                      bg="#00A2E8"
                      color="#FFFFFF"
                    >
                      Create Program
                    </Button>
                  </HStack>
                </Box>
              </Flex>
            </Container>
            <hr />
          </Box>

          <Container>
            <Flex justify="flex-end" mt="12">
              <Link href="/dashboard/knowledge-bank/programs">
                <Text>See all</Text>
              </Link>
            </Flex>

            <Stack mb="12" spacing="12">
              {/* category1: my programs */}
              <Box>
                <Grid templateColumns="auto 1fr" alignItems="center" mb="8">
                  <Text
                    sx={{
                      color: "#3981C5",
                      textTransform: "uppercase",
                      fontSize: "22px",
                      mr: "4",
                    }}
                  >
                    my programs
                  </Text>
                  <hr />
                </Grid>

                {view === "grid" ? (
                  <Grid gap={6} templateColumns="repeat(4, 1fr)">
                    {personalPrograms.map((program, i) => (
                      <PersonalProgramCard
                        program={program}
                        key={`personalProgramsList${i}`}
                      />
                    ))}
                  </Grid>
                ) : (
                  personalPrograms.map((program, i) => (
                    <PersonalProgramList
                      program={program}
                      key={`personalProgramsList${i}`}
                    />
                  ))
                )}
              </Box>

              {/* category2: suggested programs */}
              <Box>
                <Grid templateColumns="auto 1fr" alignItems="center" mb="8">
                  <Text
                    sx={{
                      color: "#3981C5",
                      textTransform: "uppercase",
                      fontSize: "22px",
                      mr: "4",
                    }}
                  >
                    suggested
                  </Text>
                  <hr />
                </Grid>

                {view === "grid" ? (
                  <Grid gap={6} templateColumns="repeat(4, 1fr)">
                    {suggestedPrograms.map((program, i) => (
                      <ProgramCard
                        key={`suggestedPrograms${i}`}
                        program={program}
                      />
                    ))}
                  </Grid>
                ) : (
                  suggestedPrograms.map((program, i) => (
                    <ProgramList
                      key={`suggestedProgramsList${i}`}
                      program={program}
                    />
                  ))
                )}
              </Box>
            </Stack>
          </Container>
        </>
      </Route>

      <Route exact path="/dashboard/knowledge-bank/subscribe">
        <SubscribeToProgram />
      </Route>

      <Route path="/dashboard/knowledge-bank/programs">
        <Programs />
      </Route>
    </Switch>
  );
};

export default KnowledgeBank;
